import React from 'react';
import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';
import { useStyletron } from 'styletron-react';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG } from './formConfig';
import delinkUserDetails from './delinkUser';

const UserDetails: React.FC<{}> = () => {
	const { showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = delinkUserDetails();
	const [css] = useStyletron();
	return (
		<div>
			<h3
				className={css({
					textAlign: 'center',
					marginTop: '20px',
					marginBottom: '20px'
				})}>
				Please enter uid of user to delink
			</h3>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				buttonLabels={{
					submitLabel: 'Submit',
					discardLabel: 'Back'
				}}
			/>
		</div>
	);
};

export default UserDetails;
